import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBannersCampaign } from '~store/campaignV2/thunks';
import { Catalog } from '~api/catalog';

export const getSlidingBannerProducts = createAsyncThunk(
  'campaignV2/getSlidingBannerProducts',
  async ({ titleId, section, params }) => {
    const response = await Catalog.getProductBrandCampaignV2(
      {
        id: titleId,
        section: section,
      },
      params,
    );
    return response.data?.data;
  },
);

export const getCategoryProducts = createAsyncThunk(
  'campaignV2/getCategoryProducts',
  async ({ titleId, section, params, append = false }) => {
    const response = await Catalog.getProductBrandCampaignV2(
      {
        id: titleId,
        section: section,
      },
      params,
    );

    return {
      data: response.data?.data || [],
      append,
    };
  },
);

const { reducer } = createSlice({
  name: 'campaignV2',
  initialState: {
    campaign: '',
    campaignBanners: [],
    brandProducts: [],
    slidingBannerProducts: [],
    categoryProducts: [],
    tabKeyActive: '',
    status: {
      campaignBanners: 'idle',
      brandProducts: 'idle',
      slidingBannerProducts: 'idle',
      categoryProducts: 'idle',
    },
  },
  reducers: {
    setState(state, { value, name }) {
      state[name] = value;
    },
    setStatusApi(state, { value, name }) {
      state.status[name] = value;
    },
    resetState(state) {
      state.campaign = '';
      state.campaignBanners = [];
      state.brandProducts = [];
      state.slidingBannerProducts = [];
      state.categoryProducts = [];
      state.tabKeyActive = '';
      state.status = {
        campaignBanners: 'idle',
        brandProducts: 'idle',
        slidingBannerProducts: 'idle',
        categoryProducts: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannersCampaign.pending, (state, action) => {
        state.status.campaignBanners = 'loading';
      })
      .addCase(getBannersCampaign.rejected, (state, action) => {
        state.status.campaignBanners = 'error';
      })
      .addCase(getBannersCampaign.fulfilled, (state, { payload }) => {
        state.status.campaignBanners = 'finished';
        state.campaignBanners = payload?.section?.data?.sections || [];
        state.campaign = payload?.campaign?.data || '';
      })
      .addCase(getSlidingBannerProducts.pending, (state, action) => {
        state.status.slidingBannerProducts = 'loading';
      })
      .addCase(getSlidingBannerProducts.rejected, (state, action) => {
        state.status.slidingBannerProducts = 'error';
      })
      .addCase(getSlidingBannerProducts.fulfilled, (state, { payload }) => {
        state.slidingBannerProducts = payload;
        state.status.slidingBannerProducts = 'finished';
      })
      .addCase(getCategoryProducts.pending, (state, action) => {
        state.status.categoryProducts = 'loading';
      })
      .addCase(getCategoryProducts.rejected, (state, action) => {
        state.status.categoryProducts = 'error';
      })
      .addCase(getCategoryProducts.fulfilled, (state, { payload }) => {
        const { data, append } = payload;

        state.categoryProducts = append
          ? [...state.categoryProducts, ...data]
          : data;

        state.status.categoryProducts = 'finished';
      });
  },
});

export default reducer;
